import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { noop, uniqueId } from 'lodash';
import {
  faEllipsisV,
  faFolderPlus,
  faInfoCircle,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { createBemBlockBuilder, ToolButton } from '@ebsco-ui/ebsco-ui';

import { Dropdown } from '@app/components';

import './MoreToolsDropdown.scss';

export const RECORD_TOOLS = {
  details: {
    label: (
      <FormattedMessage id="recordTools.details" defaultMessage="Details" />
    ) as unknown as string,
    icon: faInfoCircle,
    onClick: noop,
  },
  addToProject: {
    label: (
      <FormattedMessage
        id="recordTools.addToProject"
        defaultMessage="Add to project"
      />
    ) as unknown as string,
    icon: faFolderPlus,
    onClick: noop,
  },
  delete: {
    label: (
      <FormattedMessage id="recordTools.delete" defaultMessage="Delete" />
    ) as unknown as string,
    icon: faTrash,
    onClick: noop,
  },
};

interface MoreToolsDropdownProps {
  tools: (typeof RECORD_TOOLS.details)[];
  id?: string;
}

const cnBem = createBemBlockBuilder(['moreToolsDropdown']);

export const MoreToolsDropdown: FC<MoreToolsDropdownProps> = ({
  tools,
  id = uniqueId('more-tools-dropdown-'),
}) => {
  const { $t } = useIntl();

  return (
    <Dropdown
      id={id}
      variant="MENUBUTTON"
      items={tools}
      className={cnBem('__wrapper')}
      CustomToggle={({ getToggleButtonProps }) => (
        <ToolButton
          {...getToggleButtonProps()}
          title={$t({
            id: 'tools.tools',
            defaultMessage: 'Tools',
          })}
          defaultIcon={faEllipsisV}
        />
      )}
      onSelectedItemChange={({ selectedItem }) => {
        (selectedItem?.onClick ?? noop)();
      }}
    />
  );
};
